import "@/App.css";
import "./components/AustenGame.css";
import GameShell from "./components/GameShell";

function App() {
  return <GameShell />;
}

export default App;
